/**
 * User group types from Cognito
 */
export enum UserGroup {
  CUSTOMER = 'Customer',
  INTERNAL = 'Internal',
  SUPERADMIN = 'SuperAdmin'
}